import controller from './tableGridRemoveCell.controller';
import _ from 'lodash';

let tableGridRemoveCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns :'=',
      metaData : '='
    },
    template: '<button id="{{vm.cellValue}}" ng-click="vm.remove(vm.column,vm.cellValue,vm.metaData)" ><span class="icon remove-icon" aria-hidden="true"></span></button>',
    controller,
    controllerAs: 'vm',
    link: (scope,el,attr,ctrl) => {
      scope.vm = scope;
      scope.vm.cellValue = scope.row.id;
      scope.vm.column = _.find(scope.columns,{name: scope.columnName});
      scope.vm.remove = ctrl.remove;
    }
  };
};

export
default tableGridRemoveCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridRemoveCell/tableGridRemoveCell.component.js